module.exports = __webpack_public_path__ + "img/iiasa_logo.8fda0360.png";